import { useLayoutEffect, useState } from 'react';

const useOnResize = (callback, debounceTime = 250) => {
  const [onResize, setOnResize] = useState(false);
  let resizeTimer;

  useLayoutEffect(() => {
    const onResizeDebounced = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => setOnResize(prev => !prev), debounceTime);
    };
    window.addEventListener('resize', onResizeDebounced);

    return () => window.removeEventListener('resize', onResizeDebounced);
  }, []);

  useLayoutEffect(callback, [onResize]);

  return null;
};

export default useOnResize;
